import { Col, Row, Select, Card, Modal } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  // citiesUrl,
  fleetsUrl,
  vehicleStatusCountApiUrl,
  vehicleStatusListApiUrl,
} from "../../Common/endpoints";
import { getApis } from "../../Common/apis";
import "./styles.css";
import { ORG_TYPES, ROLES } from "../../Common/Constants";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import { FLEET_STATUS } from "../../Common/Grafana/Constants";
import { getGrafanaBaseURL } from "../../Common/Utils";
import GetIframe from "../../Common/Grafana/GetIframe";
import { SmileOutlined } from "@ant-design/icons";
import RUNNING from "../../../assets/images/icons/running-vehicle.svg";
import STOPPED from "../../../assets/images/icons/stopped-vehicle.svg";
import IDLING from "../../../assets/images/icons/idling-vehicle.svg";
import OFFLINE from "../../../assets/images/icons/offline-vehicle.svg";
import CHARGING from "../../../assets/images/icons/charging-vehicle.svg";
import TOWING from "../../../assets/images/icons/towing-vehicle.svg";
import VehiclesListTable from "../../Common/VehiclesListTable";
import { useDispatch } from "react-redux";
import { setPageLoader } from "../../../reducers/loaderSlice";

const FleetMonitor = () => {
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [fleetList, setFleetList] = useState(null);
  const [fleet, setFleet] = useState(null);
  // const [cities, setCities] = useState([]);
  // const [city, setCity] = useState("Bangalore");
  const [vehicleListModalDetails, setVehicleListModalDetails] = useState({
    status: null,
  });
  const [vehicleStatusCountDetails, setVehicleStatusCountDetails] = useState(
    {}
  );
  const authToken = localStorage.getItem("authToken");
  const checkAccess = useRequiredAccess(
    [ROLES.ADMIN, ROLES.EXECUTIVE, ROLES.FLEET_MANAGER],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  const baseFilterObject = useMemo(() => {
    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      refresh: "30s",
      fleet_id: fleet,
      // city: city,
    };
    // eslint-disable-next-line
  }, [fleet]);

  const onChangeFleet = (value) => {
    setFleet(value);
  };

  // const onChangeCity = (value) => {
  //   setCity(value);
  // };

  // const getCities = async () => {
  //   await getApis(citiesUrl, {}, authToken)
  //     .then((response) => {
  //       setCities(response?.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getFleets = async () => {
    await getApis(fleetsUrl, {}, authToken)
      .then((response) => {
        setFleetList(response?.data);
        setFleet(response?.data[0]?.fleetId);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVehicleStatusCount = useCallback(async () => {
    await getApis(
      vehicleStatusCountApiUrl,
      {
        fleetId: fleet,
      },
      authToken
    )
      .then((response) => {
        dispatch(setPageLoader("live"));
        setVehicleStatusCountDetails(response?.data);
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        dispatch(setPageLoader("live"));
      });
    // eslint-disable-next-line
  }, [authToken, fleet]);

  const getVehicleStatusList = useCallback(async () => {
    await getApis(
      vehicleStatusListApiUrl,
      {
        fleetId: fleet,
        page: 0,
        size: 10,
      },
      authToken
    )
      .then((response) => {
        setVehicleListModalDetails((prev) => ({
          ...prev,
          ...(response?.data || {}),
        }));
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        setVehicleListModalDetails({ status: null });
      });
    // eslint-disable-next-line
  }, [authToken, fleet]);

  useEffect(() => {
    if (fleet) {
      getVehicleStatusCount();
      getVehicleStatusList();

      const intervalId = setInterval(() => {
        dispatch(setPageLoader("refresh"));
        getVehicleStatusCount();
        getVehicleStatusList();
      }, 60 * 1000);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line
  }, [fleet]);

  useEffect(() => {
    checkAccess();
    dispatch(setPageLoader("refresh"));
    getFleets();

    // if (cities.length === 0) {
    //   getCities();
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vehicleStatusCard = (status, count, icon) => {
    return (
      <Card
        title={status[0].toUpperCase() + status.slice(1) + " Vehicles"}
        className={status + " status-card"}
      >
        <Row className="h100" justify={"center"} align={"middle"} wrap={true}>
          <Col>
            <img src={icon} alt="stops" className="icon" />
          </Col>
          <Col>
            <div className="status-count ml1">{count}</div>
          </Col>
          <Col span={24}>
            <div
              className={"link text-center" + (!count ? " list-disabled" : "")}
              data-testid={status + "-vehicle-list"}
              onClick={
                count
                  ? () =>
                      setVehicleListModalDetails((prev) => ({
                        ...prev,
                        status: status.toUpperCase(),
                        fleetId: fleet,
                      }))
                  : null
              }
            >
              Vehicles List
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  return fleetList?.length > 0 ? (
    <Row
      gutter={[16, 16]}
      className="fleet-status-page"
      data-testid="fleet-status"
    >
      {vehicleListModalDetails?.status ? (
        <Modal
          title={
            vehicleListModalDetails?.status[0] +
            vehicleListModalDetails?.status.slice(1).toLowerCase() +
            " Vehicles List"
          }
          open={vehicleListModalDetails?.status !== null}
          onCancel={() =>
            setVehicleListModalDetails((prev) => ({ ...prev, status: null }))
          }
          className="vehicle-status-list-modal"
          footer={false}
          width={600}
          style={{ top: "20px" }}
        >
          <VehiclesListTable
            vehicleListModalDetails={vehicleListModalDetails}
          />
        </Modal>
      ) : null}
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            {fleetList?.length > 0 && (
              <Select
                showSearch
                data-testid="fleet"
                value={fleet || fleetList?.[0]?.fleetId}
                style={{ width: "100%" }}
                onChange={onChangeFleet}
                options={fleetList.map((i) => ({
                  label: i.fleetName,
                  value: i.fleetId,
                }))}
              />
            )}
          </Col>
          {/* <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            {cities?.length > 0 && (
              <Select
                data-testid="city"
                showSearch
                value={city}
                style={{ width: "100%" }}
                onChange={onChangeCity}
                options={cities?.map((i) => ({
                  label: i,
                  value: i,
                }))}
              />
            )}
          </Col> */}
        </Row>

        <Row gutter={[16, 16]} className="mt1">
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "running",
              vehicleStatusCountDetails?.running || 0,
              RUNNING
            )}
          </Col>
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "stopped",
              vehicleStatusCountDetails?.stopped || 0,
              STOPPED
            )}
          </Col>
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "idling",
              vehicleStatusCountDetails?.idling || 0,
              IDLING
            )}
          </Col>
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "offline",
              vehicleStatusCountDetails?.offline || 0,
              OFFLINE
            )}
          </Col>
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "charging",
              vehicleStatusCountDetails?.charging || 0,
              CHARGING
            )}
          </Col>
          <Col xs={24} sm={8} md={8} lg={4} xl={4}>
            {vehicleStatusCard(
              "towing",
              vehicleStatusCountDetails?.towing || 0,
              TOWING
            )}
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="mt1">
          <Col span={24} id="vehicle-location">
            <GetIframe
              title="Vehicle Location"
              url={getGrafanaBaseURL(
                FLEET_STATUS.DASHBOARD_ID,
                FLEET_STATUS.DASHBOARD_NAME
              )}
              panelId={FLEET_STATUS.PANEL_ID["vehiclesMap"]}
              variableObject={baseFilterObject}
              variableKeys={FLEET_STATUS.FLEET_VARIABLES}
              width="100%"
              height="650"
              divId="vehicle-location"
              className="mh100"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  ) : fleetList ? (
    <Row
      justify="center"
      align={"middle"}
      className="w100 hv25 flex-center fleet-status-page"
    >
      <Col span={24} className="text-center">
        <div>
          <SmileOutlined
            className="icon-font32 mb05 text-center"
            style={{ color: "#667085" }}
          />
        </div>
        <div className="grey f13">No Fleet</div>
      </Col>
    </Row>
  ) : null;
};

export default FleetMonitor;
